module.exports = __webpack_public_path__ + "static/media/Late Quartet.3ee4b225.png";